/**
 * Styled Components - Created by cazarez on 02/03/18.
 */
import styled, { css } from 'styled-components'
import { WHITE } from '../../../theme/colors'

const BaseStyle = css`
  cursor: pointer;
  text-decoration: none;
  position: relative;
`

export const StyledA = styled.a`
  color: ${WHITE};
  ${BaseStyle}
`
export const StyledSpan = styled.span`
  ${BaseStyle}
  a {
    color: ${WHITE};
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Common/UnderlinedLink/styledComponents.tsx